import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavBarchartIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.7923 3.20898H10.209C6.34299 3.20898 3.20898 6.34299 3.20898 10.209V17.7923C3.20898 21.6583 6.34299 24.7923 10.209 24.7923H17.7923C21.6583 24.7923 24.7923 21.6583 24.7923 17.7923V10.209C24.7923 6.34299 21.6583 3.20898 17.7923 3.20898Z",
		fill: "#E2EDFF",
		stroke: "#354C8F"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.95117 18.9256V12.9767M14.144 18.9256V9.07422M19.0498 18.9256V11.4566",
		stroke: "#354C8F",
		strokeLinecap: "round"
	})]
});
export default SvgNavBarchartIcon;
